
import DashboardAppInfo from '@/components/dashboard/DashboardAppInfo.vue';
import RefDashboard from '@/components/dashboard/ReferenceDashboard.vue';
import ReferenceMatchPie from '@/components/dashboard/ReferenceMatchPie.vue';
import LastGenerationCategoryPie from '@/components/dashboard/LastGenerationCategoryPie.vue';
import ProjectDashboard from '@/components/dashboard/ProjectDashboard.vue';
import MatchedFilesDashboard from '@/components/dashboard/MatchedFilesDashboard.vue';
import SubmitIdeas from '@/components/dashboard/SubmitIdeas.vue';
import DashboardCaseInfo from '@/components/dashboard/DashboardCaseInfo.vue';
import ProjectFilesTableSmall from '@/components/files/ProjectFilesTableSmall.vue';
import ProjectsTableSmall from '@/components/projects/ProjectsTableSmall.vue';
import { Get } from 'vuex-pathify';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { IDashboardResource, IAppInfo } from '@/types/resource.types';
import dashboardService from '@/services/DashboardService';

@Component({
    name: 'DashboardView',
    components: {
        DashboardAppInfo,
        DashboardCaseInfo,
        ProjectFilesTableSmall,
        ProjectsTableSmall,
        SubmitIdeas,
        RefDashboard,
        ProjectDashboard,
        ReferenceMatchPie,
        LastGenerationCategoryPie,
        MatchedFilesDashboard
    }
})
export default class DashboardView extends Vue {

    /* Data
    ============================================*/

    dashboardResource: IDashboardResource | null = null;
    showPopout: boolean = false;
    @Get('appInfo')
    readonly appInfo: IAppInfo | null;

    /* Methods
    ============================================*/


    /* Lifecycle Hooks
    ============================================*/

    async beforeMount() {
        this.dashboardResource = await dashboardService.getDashboard();    
    }
}

